import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../utils/constant';

export const USER = 'ahov4-user';
export const UID_KEY = 'ahov4-uid';
export const EMAIL_KEY = 'ahov4-email';
export const CURRENT_USER_ROLE = 'ahov4-role';
export const CURRENT_USER_COMPANY = 'ahov4-company';
export const DEPARTMENT_OWN = 'ahov4-department';

export default function useLogin () {
  const history = useHistory();
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    const hasLoginBefore = sessionStorage.getItem(UID_KEY);

    if (!hasLoginBefore) {
      setIsLogin(false);
      history.push(ROUTES.login);
      return;
    }

    setIsLogin(true);
  }, [history]);

  return { isLogin };
}
